/* eslint-disable no-plusplus */
import React from 'react';
import { Loader } from '@getro/rombo';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';

import { Board } from '../../../../components/organisms/board';
import { ContactKanbanCard } from './components/contactKanbanCard';
import { useKanban } from './hooks/useKanban';

export const ContactsKanbanView = ({ list, queryParams, customFields, isLoadingData }) => {
  const {
    isInitialized,
    columns,
    onCreateColumn,
    onNewColumnName,
    onDeleteColumn,
    onMoveCardToAnotherColumn,
    onMoveColumn,
  } = useKanban({
    list,
    queryParams,
    customFields,
    isLoadingData,
  });

  return !isInitialized ? (
    <Flex mt="40px" flex="1" justifyContent="center" alignItems="center">
      <Loader />
    </Flex>
  ) : (
    <Board
      data={{ columns }}
      CardComponent={ContactKanbanCard}
      onCreateColumn={onCreateColumn}
      onNewColumnName={onNewColumnName}
      onDeleteColumn={onDeleteColumn}
      onMoveCardToAnotherColumn={onMoveCardToAnotherColumn}
      onMoveColumn={onMoveColumn}
      disableVerticalDragging
    />
  );
};

ContactsKanbanView.propTypes = {
  list: PropTypes.object.isRequired,
  queryParams: PropTypes.object.isRequired,
  customFields: PropTypes.array,
  isLoadingData: PropTypes.bool,
};

ContactsKanbanView.defaultProps = {
  customFields: [],
  isLoadingData: false,
};
